<template>
  <div style="height: 50vh;padding-bottom: 1px;overflow-y: auto">
    <el-row class="border-dash" style="padding: 30px">
      <div class="text-blue font-weight-bold">显示方式</div>
      <div class="margin-top-10" style="padding: 0 30px">
        <el-radio-group @change="typeChange" v-model="displaySetting.type">
          <el-radio :key="item.label" :label="item.label" style="margin-top: 7px;"
                    v-for="item in typeRadios">{{ item.name }}
          </el-radio>
        </el-radio-group>
      </div>
    </el-row>
    <el-row class="border-dash margin-top-10" style="padding: 30px;min-height: 35vh;"
            v-if="displaySetting.type === '3' || displaySetting.type === '4'">
      <div class="text-blue font-weight-bold">常显设置</div>
      <div class="margin-top-10" style="padding: 0 30px">
        <el-radio-group @change="displayChange" v-model="displaySetting.display">
          <el-radio :key="item.label" :label="item.label" style="margin-top: 7px;"
                    v-for="item in displayRadios">{{ item.name }}
          </el-radio>
        </el-radio-group>
      </div>
      <div class="margin-top-20" style="padding: 0 0 0 57px" v-if="checkBoxGroup.length">
        <el-checkbox-group size="small" v-model="displaySetting.checkboxList">
          <el-checkbox :key="item.id" :label="item.id" style="min-width: 28.5%"
                       v-for="item in checkBoxGroup">{{ item.name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </el-row>
  </div>
</template>

<script>
import {getListByParentCode} from "@/network/extension";
import {getDeviceCategoryList} from "@/network/device-category";
import {getDeviceList} from "@/network/device-info";
import {displayRadioList, typeRadioList} from "@/constant/indoor-setting-type";

export default {
  name: "DisplaySetting",
  props: ['dialogData'],
  data() {
    return {
      displaySetting: {
        type: '2', //显示方式
        display: '1', //常显设置
        checkboxList: [],
      },
      checkBoxGroup: [],
      typeList: [], //设备类型
      tagList: [], //类型标签
      deviceList: [],//设备
      typeRadios: [],
      displayRadios: [],
    }
  },
  mounted() {
    this.typeRadios = typeRadioList;
    this.displayRadios = displayRadioList;
    this.getDeviceCategoryList();
    this.getTags();
    this.getDeviceList();
  },
  watch: {
    displaySetting: {
      handler(val) {
        this.$emit('getDisplaySettingData', val)
      },
      deep: true,
    }
  },
  methods: {
    // 获取设备类型列表
    getDeviceCategoryList() {
      getDeviceCategoryList().then(res => {
        if (res.code === 0) {
          this.typeList = res.data.map(item => {
            item.name = item.cnName
            return item;
          })
        }
      })
    },
    // 获取设备类型标签
    getTags() {
      getListByParentCode("device_category_tag").then(res => {
        if (res.code === 0) {
          this.tagList = res.data.filter(item => item.isDisplay)
        }
      })
    },
    // 获取设备类型标签
    getDeviceList() {
      getDeviceList().then(res => {
        if (res.code === 0) {
          this.deviceList = res.data
        }
      })
    },
    typeChange(val) {
      if (val === '3' || val === '4') {
        this.displayChange(this.displaySetting.display)
      }
    },
    displayChange(val) {
      this.displaySetting.checkboxList = []
      if (val === '1') {
        this.checkBoxGroup = this.typeList
      } else if (val === '2') {
        this.checkBoxGroup = this.tagList
      } else if (val === '3') {
        this.checkBoxGroup = this.deviceList
      } else {
        this.checkBoxGroup = []
      }
    },
  }
}
</script>

<style scoped>

</style>
